<template>
  <v-app
      light>
    <!-- <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      app
    >
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer> -->
    <v-toolbar
      color="primary" dark
      app absolute clipped-left
    >
      <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      <!-- <v-icon class="mx-3">camera</v-icon> -->
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title v-if="signedIn"><span class="green-dot"/> {{ onlineUserCount }} <v-icon>people</v-icon></v-toolbar-title>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<style>
html { overflow: hidden !important; }

.green-dot {
  height: 12px;
  width: 12px;
  background-color: #0F0;
  border-radius: 50%;
  display: inline-block;
}
</style>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      drawer: false,
      items: [{
        icon: 'home',
        title: 'Menu not yet implemented'
      }],
      title: 'BlaBla.Cam'
    }
  },

  name: 'App',

  computed: {
    ...mapState([
      'signedIn', 'onlineUserCount'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue